import useColorizeSvg from 'hooks/svg/useColorizeSvg';

type Props = {
  iconUrl: string;
  iconColor: string;
};

const FacilityIcon = ({ iconUrl, iconColor }: Props) => {
  const { svgDataUri } = useColorizeSvg({
    iconUri: iconUrl,
    iconColor,
  });

  return svgDataUri ? <img className='FacilityButton_icon_img' src={svgDataUri} alt='icon' /> : null;
};
export default FacilityIcon;
